/**
 * BreadcrumbTailProvider
 *
 * Owns the state for the breadcrumb tail. Intentionally lives in its own
 * file (separate from the Context instance + hooks in
 * `BreadcrumbTailContext.ts`) so React Fast Refresh can patch either
 * side independently without invalidating the context identity.
 */

import { useMemo, useState, type ReactNode } from 'react';
import {
  BreadcrumbTailContext,
  type BreadcrumbCrumb,
  type BreadcrumbTailContextValue,
} from './BreadcrumbTailContext';

export function BreadcrumbTailProvider({ children }: { children: ReactNode }) {
  const [tail, setTailState] = useState<BreadcrumbCrumb[]>([]);

  const value = useMemo<BreadcrumbTailContextValue>(
    () => ({
      tail,
      setTail: (crumbs) => setTailState(crumbs ?? []),
    }),
    [tail],
  );

  return (
    <BreadcrumbTailContext.Provider value={value}>
      {children}
    </BreadcrumbTailContext.Provider>
  );
}

export default BreadcrumbTailProvider;
